import { SUB_LOCATION } from '../../../MediaProductCreate/MediaProductCreateForm/fields'
import { LOCATION } from '../../../fields'

export const getLocationSectionInitialValues = editProductData => {
  return {
    ...(editProductData[LOCATION]?.id && { [LOCATION]: editProductData[LOCATION]?.id }),
    ...(editProductData[SUB_LOCATION] && { [SUB_LOCATION]: editProductData[SUB_LOCATION] })
  }
}
